import { Component, inject, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiClientConstant, Table } from '@cureskin/api-client';
import { RegimenClass } from '@cureskin/api-client/src/server-api';
import { ConnectionService } from '@services/connection-service';
import { CsIconModule } from '@components/icon';
import { ChatLanguagePillComponent } from '@shared/chat-language-pill/chat-language-pill.component';

@Component({
  selector: 'consultation-chat-header',
  standalone: true,
  imports: [CommonModule, CsIconModule, ChatLanguagePillComponent],
  templateUrl: './consultation-chat-header.component.html',
})
export class ConsultationChatHeaderComponent {
  readonly consultationSession = input<Table.ConsultationSession>();
  readonly regimenClass = input<RegimenClass>();
  readonly isRegimenExpired = input(false);
  readonly botReplyInProgress = input(false);
  readonly translateChatMessages = input(true);
  readonly back = output<void>();

  private readonly conn = inject(ConnectionService);
  protected readonly RegimenClass = ApiClientConstant.Regimen.Class;

  /** The acting user is globally available — self-fetched to avoid coupling to the parent. */
  protected get user(): Table.User {
    return this.conn.getActingUser();
  }
}
